import React from 'react';
import PropTypes from 'prop-types';
import ProductSearchForm from 'app-components/Products/Search/ProductSearchForm.jsx';
import ProductSearchResults from 'app-components/Products/Search/ProductSearchResults.jsx';
import { connect } from 'react-redux';

class ProductSearch extends React.Component {
    constructor(props){
        super(props);
        this.state = { hasSearched: false };
    }

    handleSearchComplete = () => {
        this.setState({ hasSearched: true });
    };

    handleSearchReset = () => {
        this.setState({ hasSearched: false });
    };

    componentDidUpdate(prevProps) {

        if(this.props.message) {
            if(!prevProps.message) {
                this.props.showNotification(this.props.message.message, this.props.message.status);
            } else if(prevProps.message.timestamp !== this.props.message.timestamp) {
                this.props.showNotification(this.props.message.message, this.props.message.status);
            }
        }
    }

    render() {
        return (
            <div>
                <ProductSearchForm
                    showNotification={this.props.showNotification}
                    onSearchComplete={this.handleSearchComplete}
                    onSearchReset={this.handleSearchReset}
                />
                {this.state.hasSearched && <ProductSearchResults/>}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        message: state.status.message,
    }
};

ProductSearch.propTypes = {
    message: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(mapStateToProps)(ProductSearch);